
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import lengyel from "../../assets/lengyel.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarLengyel({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar lengyel fordító</title>
                <meta name='description' content="Ingyenes magyar lengyel fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar lengyel fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-lengyel-fordito" />
            </Helmet>
            <h1>Magyar lengyel fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és lengyel nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={lengyel} alt="lengyel zászló"></img>
                </div>


                <p>A magyar és a lengyel nyelv két különböző nyelv, amelyek különböző nyelvcsaládokba tartoznak. A magyar ugor-altaikus nyelvcsaládba, míg a lengyel a nyugati szláv nyelvek családjába tartozik.</p>

                <h3>Hasonlóságok</h3>

                <ul>
                    <li><b>Hangrendszerek</b>: Mind a magyar, mind a lengyel nyelv rendelkezik hangrendszerekkel. A magyarban a szavakat magas és mély hangrendekre osztjuk, míg a lengyelben a hangok hosszúsága és a hangsúlyos magánhangzók kiejtési különbségeket eredményeznek.</li>

                    <li><b>Ragok</b>: Mind a magyar, mind a lengyel nyelv gazdag ragozó nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, számokban vagy névmódokban.</li>

                    <li><b>Szórend</b>: A magyar és a lengyel nyelvben hasonló szórend jellemző. Általában az alany-állítmány-tárgy (AAT) szórendet használják, bár mindkét nyelvben lehetnek eltérések és kivételek.</li>

                    <li><b>Névmások</b>: Mind a magyar, mind a lengyel nyelvben fontos szerepet játszanak a névmások. Mindkét nyelvben különböző névmások vannak az alany, tárgy vagy birtoklás kifejezésére.</li>
                </ul>


                <h3>Különbségek</h3>
                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A magyar és a lengyel nyelv nem tartozik ugyanahhoz a nyelvcsaládhoz. A magyar ugor-altaikus, míg a lengyel a nyugati szláv nyelvek családjába tartozik.</li>

                    <li><b>Hangzások és kiejtés</b>: A magyar és a lengyel nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. A lengyel nyelvben vannak olyan hangzók, amelyek a magyarban nem találhatók meg, és fordítva.</li>

                    <li><b>Írásrendszer</b>: A magyar nyelv latin betűs írásrendszert használ, míg a lengyel nyelv lengyel ábécét, az ún. lengyel latin betűkkel kibővített ábécét használ.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a lengyel nyelv nyelvtani struktúrája is eltérő. Például a ragozás és a névmások használata a lengyelben más lehet, mint a magyarban.</li>

                    <li><b>Szókincs</b>: A magyar és a lengyel nyelvnek eltérő szókincse van, habár lehetnek átfedések bizonyos témakörökben, például az alapvető számok vagy a családi tagok kifejezése.</li>
                </ul>

                <div className="sectionbottom">
                    <Link to="/lengyel-magyar-fordito">Lengyel magyar fordító</Link>
                    <img src={lengyel} alt="lengyel zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarLengyel;